import { api } from "./client";

export interface ReportIssueRequest {
  title: string;
  description?: string;
  correlation_id?: string;
}

export interface ReportIssueResponse {
  display_id: string;
}

export function reportIssue(
  request: ReportIssueRequest,
): Promise<ReportIssueResponse> {
  return api.post<ReportIssueResponse>("/report-issue", request);
}
